export default __webpack_public_path__ + "662bdc7a437ac652c5bb33208d4770a9.svg";